const ru = {
  // Navigation
  home: 'Главная',
  rconHacking: 'RCON Аудит',
  accountChecker: 'Проверка Аккаунтов',
  ddosTesting: 'DDoS Тестирование',
  servers: 'Сервера',
  serverDataExtraction: 'Извлечение Данных',
  bots: 'Боты',
  secret: 'Zero-day метод',
  account: 'Аккаунт',
  terms: 'Условия',

  // Home Page
  socialCommunities: 'Сообщества',
  telegramCommunity: 'Telegram Канал',
  telegramLeaksDesc: 'Эксклюзивные сливы приватного софта, способов и скриптов. Будь первым в курсе обновлений.',
  discordCommunity: 'Discord Сервер',
  discordLeaksDesc: 'Обсуждение методов тестирования, помощь новичкам и прямая связь с разработчиками.',
  joinCommunity: 'Присоединиться',
  joinNow: 'Вступить',
  openLink: 'Перейти',
  serverTestTitle: 'Тест Сервера',
  serverTestDescription: 'Подключитесь к одному из серверов ниже, чтобы начать комплексное тестирование безопасности и обнаружить уязвимости',
  serverTestPlaceholder: '127.0.0.1:25565',
  serverTestButton: 'Тестировать',
  serverHackingTools: 'Инструменты аудита',
  botConnectionTools: 'Тестирование ботов',
  additionalTestingTools: 'Дополнительные',
  toolsAvailable: 'инструментов доступно',
  recentTestedServers: 'Недавно протестированные серверы',
  noRecentServersFound: 'Нет недавних серверов',
  players: 'игроков',
  tested: 'Проверено',
  proofOfEffectiveness: 'Доказательства эффективности',
  noProofsAvailable: 'Нет доказательств',
  views: 'просмотров',
  totalServersTested: 'Всего протестировано серверов',
  thisWeek: 'за эту неделю',
  vulnerabilitiesFound: 'Найдено уязвимостей',
  critical: 'Критических',
  accountsChecked: 'Проверено аккаунтов',
  valid: 'Действительных',
  activeUsers: 'Активных пользователей',
  premium: 'Премиум',
  allTools: 'Наши инструменты',

  // Authentication
  login: 'Войти',
  loggingIn: 'Вход...',
  register: 'Регистрация',
  logout: 'Выйти',
  loginWithGoogle: 'Войти через Google',
  loginRequired: 'Авторизация обязательна',
  loginRequiredDescription: 'Пожалуйста, войдите в аккаунт, чтобы просмотреть тарифы, реферальную программу и API ключи.',
  email: 'Email',
  password: 'Пароль',
  confirmPassword: 'Подтвердите пароль',
  forgotPassword: 'Забыли пароль?',
  resetPassword: 'Сбросить пароль',
  myAccount: 'Мой аккаунт',

  // Common
  loading: 'Загрузка...',
  error: 'Ошибка',
  success: 'Успех',
  cancel: 'Отмена',
  confirm: 'Подтвердить',
  close: 'Закрыть',
  save: 'Сохранить',
  edit: 'Редактировать',
  delete: 'Удалить',
  searchModules: 'Поиск модулей...',
  noResultsFound: 'Результаты не найдены',
  notifications: 'Уведомления',
  noNewNotifications: 'Нет новых уведомлений',
  viewAll: 'Посмотреть все',
  couldNotLoadProofVideos: 'Не удалось загрузить видео доказательств',
  notAuthenticated: 'Не аутентифицирован',
  quickLinks: 'Быстрые ссылки',
  pricing: 'Цены',
  blog: 'Блог',
  communityAndSupport: 'Сообщество и поддержка',
  termsOfService: 'Условия использования',
  privacyPolicy: 'Политика конфиденциальности',
  supportCenter: 'Центр поддержки',
  footerDescription: 'Продвинутый набор для тестирования безопасности серверов Minecraft. Обнаруживайте уязвимости до того, как их смогут использовать.',
  allRightsReserved: 'Все права защищены.',
  user: 'Пользователь',
  free: 'Бесплатный',
  couldNotProcessPaymentMethod: 'Не удалось обработать метод оплаты',
  couldNotProcessPaymentInitiation: 'Не удалось инициировать оплату. Пожалуйста, попробуйте еще раз.',
  unknownErrorOccurred: 'Произошла неизвестная ошибка',
  pleaseLogInToViewAccountDetails: 'Пожалуйста, войдите, чтобы просмотреть данные аккаунта',
  connectingToServer: 'Подключение к серверу...',
  failedToProcessPaymentInitiation: 'Не удалось инициировать оплату. Пожалуйста, попробуйте еще раз.',
  couldNotLoadAccountData: 'Не удалось загрузить данные аккаунта. Пожалуйста, попробуйте обновить страницу.',
  processing: 'Обработка...',
  couldNotFindDetailsForCurrentPlan: 'Не удалось найти детали для текущего плана продления.',
  iAcceptTerms: 'Я принимаю условия использования',
  paymentWindowOpened: 'Пожалуйста, завершите оплату в открывшемся окне.',
  openPaymentPage: 'Страница оплаты',
  waitingForConfirmation: 'Ожидаем поступления средств...',
  awaitingPaymentConfirmation: 'Ожидание подтверждения платежа',
  longWaitQuestion: 'Какие-то вопросы или задержки? Напишите к нам на почту',

  // Account
  accountOverview: 'Обзор Аккаунта',
  subscription: 'Подписка',
  paymentHistory: 'История Платежей',
  paymentMethods: 'Методы Оплаты',
  manageSubscription: 'Управление подпиской',
  daysLeft: 'дней осталось',
  current: 'Текущий',
  member: 'Участник',
  youHaveAccessToAllFeatures: 'У вас есть доступ ко всем функциям!',
  unlockMoreFeaturesByUpgradingToProfessional: 'Разблокируйте больше функций, перейдя на Professional',
  unlockMoreFeaturesByUpgradingToPremium: 'Разблокируйте больше функций, перейдя на Premium',
  upgradeToAPaidPlanToUnlockMoreFeatures: 'Перейдите на платный план, чтобы разблокировать больше функций.',
  serversTested: 'Протестировано серверов',
  bonusPoints: 'Бонусные очки',
  testsRemaining: 'Осталось тестов',
  resetsInDays: 'Сброс через {{days}} дней',
  noLimit: 'Без лимита',
  dailyLimit: 'Дневной лимит',
  noReceipt: 'Нет квитанции',
  successfulHacks: 'Успешных проверок',
  successRate: 'уровень успеха',
  currentSubscription: 'Текущая подписка',
  active: 'Активно',
  plan: 'План',
  billedMonthly: 'Оплата каждые 6 месяцев',
  renewsOn: 'Продление',
  changePlan: 'Сменить план',
  extendSubscription: 'Продлить подписку',
  status: 'Статус',
  price: 'Цена',
  subscriptionId: 'ID подписки',
  timeRemaining: 'Оставшееся время',
  daysUsed: 'дней использовано',
  daysTotal: 'дней всего',
  planFeatures: 'Функции плана',
  availablePlans: 'Доступные планы',
  options: 'опций',
  noPlansAvailable: 'Нет доступных планов.',
  currentPlan: 'Текущий план',
  freeTier: 'Бесплатный уровень',
  upgradeTo: 'Перейти на',
  records: 'записей',
  date: 'Дата',
  description: 'Описание',
  amount: 'Сумма',
  receipt: 'Квитанция',
  noPaymentHistoryFound: 'История платежей не найдена',
  unlockAdvancedHackingTools: 'Разблокируйте инструменты глубокого аудита',
  upgradeToProfessionalPlanToAccessAllServerTestingTools: 'Перейдите на план Professional, чтобы получить доступ ко всем инструментам анализа серверов и продвинутым методам тестирования для максимальной безопасности.',
  upgradeToProfessional: 'Перейти на Professional',
  developerTools: 'Инструменты разработчика',
  noApiKeys: 'У вас еще нет API ключей',
  referrals: 'Рефералы',

  // Referrals
  referralSystem: 'Реферальная система',
  myReferralLinks: 'Мои реферальные ссылки',
  createReferralLink: 'Создать реферальную ссылку',
  referralLinkName: 'Название ссылки (например, YouTube)',
  copyLink: 'Копировать ссылку',
  registrations: 'Регистрации',
  earnings: 'Заработок',
  referralEarnings: 'Заработано на рефералах',
  purchases: 'Покупки',
  noReferralLinksYet: 'У вас еще нет реферальных ссылок',
  referralNamePlaceholder: 'Введите название для ссылки',
  noReferrals: 'У вас еще нет рефералов',
  confirmDeleteReferral: 'Вы уверены, что хотите удалить эту реферальную ссылку?',
  referralBonus: 'Реферальный бонус',
  inviteFriendsAndEarn: 'Приглашайте друзей и получайте 10% от их покупок на свой бонусный баланс!',

  // Plan descriptions
  freePlanDescription: 'Базовый доступ к основным функциям',
  vipPlanDescription: 'Расширенные функции и приоритетная поддержка',
  premiumPlanDescription: 'Продвинутые инструменты и увеличенные лимиты',
  professionalPlanDescription: 'Полный доступ ко всем функциям и инструментам',
  apiPlanDescription: 'Доступ к REST API для программной интеграции',

  // Plan features
  basicFeature: 'Основная функция',
  advancedFeature: 'Продвинутая функция',
  professionalFeature: 'Профессиональная функция',

  apiKeysManagement: "Управление API Ключами",
  manageYourApiKeysForProgrammaticAccess: "Управляйте ключами API для программного доступа",
  createNewKey: "Создать Новый Ключ",
  noApiKeysYet: "Пока Нет API Ключей",
  createYourFirstApiKeyToStartIntegrating: "Создайте свой первый API ключ для интеграции с нашими сервисами",
  createFirstKey: "Создать Первый Ключ",
  apiKeyUsageGuidelines: "Рекомендации по Использованию API Ключей",
  keepYourApiKeysSecure: "Храните ключи в безопасности и никогда не коммитьте их в систему контроля версий",
  neverShareKeysPublicly: "Никогда не делитесь ключами публично или в клиентском коде",
  regenerateKeysIfCompromised: "Немедленно перегенерируйте ключи при подозрении на компрометацию",
  deactivateUnusedKeys: "Деактивируйте неиспользуемые ключи для поддержания безопасности",
  apiDocs: "Документация API",
  createNewApiKey: "Создать Новый API Ключ",
  giveYourKeyADescriptiveName: "Дайте ключу описательное имя",
  keyName: "Название Ключа",
  enterKeyName: "Введите название ключа",
  exampleProductionServer: "например, Продакшн Сервер",
  create: "Создать",
  name: "Название",
  actions: "Действия",
  copyToClipboard: "Копировать в буфер обмена",
  created: "Создан",
  lastUsed: "Последнее использование",
  never: "Никогда",
  requests: "Запросов",
  deactivate: "Деактивировать",
  activate: "Активировать",
  delete: "Удалить",
  confirmDeleteApiKey: "Вы уверены, что хотите удалить этот API ключ?",
  thisActionCannotBeUndone: "Это действие нельзя отменить. Приложения, использующие этот ключ, потеряют доступ.",
  apiKeyOperationFailed: "Ошибка операции с API ключом",
  apiKeyNamePlaceholder: "Название ключа (например, My App)",
  active: "Активен",
  inactive: "Неактивен",

  // API Documentation
  apiDocumentation: "Документация API",
  apiDocumentationDescription: "Узнайте, как использовать наше REST API для интеграции сервисов StormHack в ваши приложения",
  gettingStarted: "Начало Работы",
  apiGettingStartedDescription: "Для использования StormHack API вам понадобится ключ API, который можно сгенерировать в настройках вашего аккаунта. Все запросы к API должны выполняться через HTTPS и включать ваш ключ API в заголовке Authorization.",
  apiBaseUrl: "Базовый URL",
  authentication: "Аутентификация",
  apiAuthenticationDescription: "Аутентифицируйте ваши запросы к API, включая ваш ключ API в заголовок Authorization ваших запросов.",
  headers: "Заголовки",
  rateLimits: "Ограничения Частоты",
  apiRateLimitsDescription: "Запросы к API ограничены по частоте в зависимости от вашего плана подписки для обеспечения справедливого использования и стабильности сервиса.",
  freePlan: "Бесплатный План",
  apiPlan: "API План",
  professionalPlan: "Профессиональный План",
  endpoints: "Конечные Точки",
  serverInfoEndpointDescription: "Получите информацию о сервере Minecraft, включая версию, количество игроков и MOTD.",
  accountCheckerEndpointDescription: "Проверьте, есть ли у имени пользователя Minecraft связанные учетные данные в нашей базе данных.",
  exampleRequest: "Пример Запроса",
  exampleResponse: "Пример Ответа",
  errorHandling: "Обработка Ошибок",
  apiErrorHandlingDescription: "API использует стандартные коды состояния HTTP для указания успеха или неудачи запросов. Все ответы возвращаются в формате JSON.",
  exampleError: "Пример Ответа с Ошибкой",

  // Status
  connected: 'Подключено',
  disconnected: 'Отключено',
  connecting: 'Подключение...',

  // Plans
  free: 'Бесплатный',
  basic: 'Базовый',
  premium: 'Премиум',
  enterprise: 'Корпоративный',

  // Features
  feature1: 'Основная функция',
  feature2: 'Продвинутая функция',
  feature3: 'Профессиональная функция',

  // Months
  january: 'Январь',
  february: 'Февраль',
  march: 'Март',
  april: 'Апрель',
  may: 'Май',
  june: 'Июнь',
  july: 'Июль',
  august: 'Август',
  september: 'Сентябрь',
  october: 'Октябрь',
  november: 'Ноябрь',
  december: 'Декабрь',

  // Тестирование DDoS
  ddosModuleTitle: 'МОДУЛЬ ТЕСТИРОВАНИЯ DDOS',
  ddosServerStress: 'Нагрузка и устойчивость',
  ddosAssessment: 'DDOS',
  ddosDescription: 'Анализ устойчивости сервера к распространенным векторам DDoS-атак. Подключитесь к цели ниже, чтобы начать. Перед началом убедитесь, что у вас есть разрешение.',
  ddosAttackTypeSelection: 'Выбор типа атаки',
  ddosMethodsAvailable: 'Доступно 2 метода',
  ddosBotAttack: 'DDoS-атака с помощью ботов',
  ddosBotAttackDescription: 'Подключение множества бот-клиентов для перегрузки мощности сервера',
  ddosPacketAttack: 'Пакетная DDoS-атака',
  ddosPacketAttackDescription: 'Отправка большого объема некорректных пакетов для перегрузки сети',
  ddosEffectiveness: 'Эффективность',
  ddosDetectionRisk: 'Риск обнаружения',
  ddosResourceUsage: 'Использование ресурсов',
  ddosVeryHigh: 'Очень высокий',
  ddosMedium: 'Средний',
  ddosHigh: 'Высокий',
  ddosAttackConfiguration: 'Конфигурация атаки',
  ddosPacketAttackMethod: 'Метод пакетной атаки',
  ddosBotAttackMethod: 'Метод атаки ботами',
  ddosAttackIntensity: 'Интенсивность атаки',
  ddosLow: 'Низкая',
  ddosThreadCount: 'Количество потоков',
  ddosDuration: 'Продолжительность',
  ddosSeconds: 'Секунды',
  ddosMinutes: 'Минуты',
  ddosHours: 'Часы',
  ddosShowAdvancedOptions: 'Показать расширенные настройки',
  ddosAdvancedOptions: 'Расширенные настройки появятся здесь.',
  ddosStartTest: 'Начать DDoS-тест',
  ddosStopTest: 'Остановить DDoS-тест',
  ddosProcessing: 'Обработка...',
  ddosAttackMonitoring: 'Мониторинг атаки',
  ddosActive: 'Активна',
  ddosNotActive: 'Не активна',
  ddosPacketsSent: 'Отправлено пакетов',
  ddosDataSent: 'Отправлено данных',
  ddosTargetPing: 'Пинг цели',
  ddosTargetStatus: 'Статус цели',
  ddosOnline: 'Онлайн',
  ddosRunning: 'Работает',
  ddosStressed: 'Перегружен',
  ddosLagging: 'Замедлен',
  ddosOffline: 'Офлайн',
  ddosCrashed: 'Аварийно завершен',
  ddosTrafficRate: 'Скорость трафика',
  ddosPacketsPerSec: 'Пакетов/сек',
  ddosBandwidth: 'Пропускная способность',
  ddosCpuUsage: 'Прим. загрузка ЦП',
  ddosServerResponse: 'Ответ сервера',
  ddosResponseTime: 'Время ответа',
  ddosTimeoutRate: 'Частота тайм-аутов',
  ddosPlayersOnline: 'Игроков онлайн',
  ddosAttackCompleted: 'Атака завершена. Просмотрите результаты ниже.',
  ddosAttackError: 'Атака прервана из-за ошибки.',
  ddosStartVisualization: 'Запустите атаку, чтобы увидеть визуализацию сети',
  ddosSynFlood: 'SYN-флуд',
  ddosUdpFlood: 'UDP-флуд',
  ddosPingFlood: 'Ping-флуд (ICMP)',
  ddosTcpBypass: 'Обход TCP',
  ddosConnectionFlood: 'Флуд подключениями',
  ddosChatSpam: 'Спам / флуд в чате',
  ddosJoinFlood: 'Флуд входами/выходами',
  ddosLagExploit: 'Бот-эксплойт задержки',
  ddosAttackDurationTip: 'Продолжительность атаки',
  ddosAttackDurationDesc: 'Коротких тестов (30-60 секунд) обычно достаточно для оценки уязвимостей без продолжительного простоя. Более длительные тесты повышают риск обнаружения и могут запустить автоматические системы защиты.',
  ddosUseVpn: 'Использовать VPN',
  ddosUseVpnDesc: 'Всегда используйте VPN при проведении DDoS-тестирования, чтобы защитить свою личность и избежать потенциальных блокировок IP. Меняйте конечные точки VPN между тестами, чтобы избежать попадания в черный список.',
  ddosLegalConsiderations: 'Юридические аспекты',
  ddosLegalConsiderationsDesc: 'DDoS-тестирование без явного разрешения является незаконным в большинстве юрисдикций и может привести к серьезным юридическим последствиям. Всегда получайте письменное разрешение от владельцев сервера перед проведением тестов.',
  ddosConnectToServer: 'Невозможно настроить DDoS-атаку. Сначала подключитесь к работающему серверу.',
  ddosAttackLog: 'Журнал DDoS-атаки',
  ddosClearLog: 'Очистить журнал',
  rememberToUseThisToolResponsibly: 'Помните, что этот инструмент необходимо использовать ответственно.',
  ddosProtectionAnalysis: 'Анализ DDoS-защиты',
  ddosDetectedProtection: 'Обнаруженная защита',
  ddosNoProtectionData: 'Данные о защите отсутствуют',
  ddosUnknownProtection: 'Неизвестная защита',
  ddosNoDescription: 'Нет описания',
  ddosRecommendations: 'Рекомендации',
  ddosNoRecommendations: 'Рекомендации отсутствуют',
  ddosRecommendation: 'Рекомендация',
  ddosNoDetailsProvided: 'Подробности не предоставлены.',
  ddosTestResultsHistory: 'Результаты и история тестов',
  ddosNoTestResults: 'Результаты тестов пока отсутствуют. Запустите тест, чтобы увидеть их здесь.',
  ddosSuccessful: 'Успешно',
  ddosFailed: 'Сбой / Неэффективно',
  ddosLastTestResult: 'Результат последнего теста',
  ddosTestSummary: 'Сводка теста ({{timestamp}})',
  ddosTestType: 'Тип:',
  ddosDuration: 'Продолжительность:',
  ddosShowLess: 'Показать меньше',
  ddosShowDetails: 'Показать детали',
  ddosOverallResult: 'Общий результат',
  ddosTargetStatusAfter: 'Статус цели после',
  ddosUnknown: 'Неизвестно',
  ddosSummaryMessage: 'Сводное сообщение',
  ddosNoSummary: 'Сводка не предоставлена.',
  ddosAttackMetrics: 'Метрики атаки',
  ddosMaxPackets: 'Макс. пакетов/с',
  ddosAvgBandwidth: 'Ср. пропускная способность',
  ddosTotalDataSent: 'Всего данных отправлено',
  ddosServerResponse: 'Ответ сервера',
  ddosHighestPing: 'Максимальный пинг',
  ddosTimeouts: 'Тайм-ауты',
  ddosLowestPlayers: 'Минимальное кол-во игроков',
  ddosVulnerabilitiesFound: 'Обнаружено уязвимостей',
  ddosExportDetails: 'Экспортировать детали',
  ddosTargetServer: 'Целевой сервер',
  ddosConnection: 'Подключение',
  ddosEnterTargetServer: 'Введите IP-адрес сервера, на котором вы хотите провести DDoS-тестирование. Убедитесь, что у вас есть разрешение, прежде чем продолжить.',
  ddosTargetServerPlaceholder: 'IP-адрес целевого сервера (напр., mc.server.com)',
  ddosConnecting: 'Подключение...',
  ddosConnectToServer: 'Подключиться к серверу',

  // RCON Hacking
  rconModuleTitle: 'МОДУЛЬ RCON',
  rconRemoteConsole: 'Удаленная консоль',
  rconAccess: 'RCON',
  rconDescription: 'Сканирование открытых портов RCON и попытка подбора паролей с помощью комплексных словарей. Подключитесь к серверу ниже.',
  rconCommonPorts: 'Общие порты RCON',
  rconStandardPort: 'Стандартный порт Minecraft RCON',
  rconUnusualPort: 'Порт сервера Minecraft (необычно для RCON)',
  rconHighConfidence: 'Высокая уверенность',
  rconMediumConfidence: 'Средняя уверенность',
  rconResponseTime: 'Время отклика',
  rconProtocolVersion: 'Версия протокола',
  rconAuthentication: 'Аутентификация',
  rconCrackPassword: 'Проверить пароль',
  rconScannerConfig: 'Конфигурация портов',
  rconCrackerConfig: 'Конфигурация паролей',
  rconScanMode: 'Режим сканирования',
  rconDefinesPortRange: 'Определяет диапазон портов',
  rconFastMode: 'Быстрый (Обычный: ~25700-30000)',
  rconMiddleMode: 'Средний (Шире: ~10000-40000)',
  rconFullMode: 'Полный (Все: 1024-65535)',
  rconScanThreads: 'Потоки (Сканирование)',
  rconLow: 'Низкий',
  rconMedium: 'Средний',
  rconHigh: 'Высокий',
  rconScanTimeout: 'Таймаут сканирования (мс)',
  rconPasswordDatabase: 'База данных паролей',
  rconLoadingBases: 'Загрузка баз...',
  rconWaitingPasswordBase: 'Ожидание списка баз паролей с сервера...',
  rconThreadsCrack: 'Потоки (Аудит)',
  rconRequestDelay: 'Таймаут сканирования',
  rconFast: 'Быстро',
  rconBalanced: 'Сбалансировано',
  rconStealthy: 'Скрытно',
  rconProcessing: 'Обработка...',
  rconAccessGranted: 'Доступ предоставлен',
  rconCrackPort: 'Проверить порт',
  rconStartRconCrack: 'Начать аудит RCON',
  rconSelectPasswordDatabase: 'Выберите базу данных паролей',
  rconPortScanner: 'Сканер портов RCON',
  rconRunning: 'Работает...',
  rconReady: 'Готов',
  rconStopScan: 'Остановить сканирование',
  rconStartScan: 'Начать сканирование',
  rconScanningPortRange: 'Сканирование диапазона портов: 1000-30000',
  rconComplete: 'Завершено',
  rconPortsScanned: 'Портов просканировано',
  rconOpenPorts: 'Открытые порты',
  rconRconCandidates: 'Кандидаты RCON',
  rconStopScanButton: 'Остановить сканирование',
  rconClearResults: 'Очистить результаты',
  rconContinuePasswordCracker: 'Продолжить проверку паролей',
  rconPasswordCracking: 'Аудит паролей',
  rconLockedUntilPortSelected: 'Заблокировано до выбора порта',
  rconSelectDetectedPort: 'Выберите обнаруженный порт RCON для начала проверки паролей',
  rconStartPasswordCracker: 'Запустить аудит паролей',
  rconConnectDirectly: 'Прямое подключение (если RCON известен)',
  rconRconPort: 'Порт RCON',
  rconRconPassword: 'Пароль RCON',
  rconConnect: 'Подключиться',
  rconScanPort: 'Сканировать порт',
  rconCrackPasswordStep: 'Проверить пароль',
  rconRconConsole: 'Консоль RCON',
  rconDetectedRconPorts: 'Обнаруженные порты RCON',
  rconCommonRconPorts: 'Общие порты RCON',
  rconPasswordStrategy: 'Стратегия паролей',
  rconPatienceIsKey: 'Терпение - ключ к успеху',
  rconHackingTips: 'Советы по аудиту RCON',
  rconProTips: 'Профессиональные советы',
  rconStandardPortTip: 'Большинство серверов используют порт 25575 для RCON по умолчанию.',
  rconPasswordStrategyTip: 'Начните с вариаций названия сервера, затем общих паролей Minecraft, затем стандартных словарей.',
  rconPatienceTip: 'Аудит RCON может занять время. Более высокие значения задержки снижают риск обнаружения, но замедляют процесс.',
  rconStandardPortDetails: 'Стандартный порт RCON обычно 25575, но некоторые серверы используют вариации, такие как 25576, 25585 или даже нестандартные порты для безопасности.',
  rconPasswordOrder: 'Эффективный порядок подбора паролей: 1) Вариации названия сервера 2) "minecraft", "password", "admin" 3) Топ 1000 паролей 4) Полный словарь',
  rconDelaySettings: 'Рекомендуемые настройки задержки: 50 мс для быстрых сетей, 150-300 мс для сбалансированного подхода, 500 мс+ для скрытной проверки',
  rconNote: 'Примечание: Аудит RCON следует выполнять только на серверах, которыми вы владеете или имеете разрешение на тестирование.',
  rconLegalDisclaimer: 'Юридический отказ от ответственности',
  rconEthicalGuidelines: 'Этические принципы',
  rconSuccessRconAccess: 'Успех! Доступ к RCON предоставлен на порту',
  rconPassword: 'Пароль',
  rconSendCommandsConsole: 'Теперь вы можете отправлять команды через консоль выше.',
  rconCannotSendCommand: 'Невозможно отправить команду: Доступ к RCON не предоставлен или отсутствует подключение.',
  rconCannotConnectManually: 'Невозможно подключиться вручную: Проверьте подключение к серверу или текущий процесс.',
  rconInitiatingRconProcess: 'Инициация процесса RCON для',
  rconCannotStart: 'Невозможно начать',
  rconServerNotConnected: 'Сервер не подключен или находится офлайн.',
  rconWebSocketNotConnected: 'WebSocket не подключен. Пожалуйста, подождите или обновите страницу.',
  rconProcessAlreadyRunning: 'Невозможно начать: Процесс уже запущен.',
  rconSelectPasswordBase: 'Пожалуйста, выберите базу данных паролей перед взломом.',
  rconConfigurationIncomplete: 'Конфигурация неполная',
  rconNoPasswordBases: 'Нет загруженных баз паролей и ни одна не выбрана. Невозможно начать процесс RCON.',
  rconConfigurationError: 'Ошибка конфигурации',
  rconRequestingProcessStop: 'Запрос остановки процесса...',
  rconNoActiveProcess: 'Нет активного процесса для остановки или отсутствует подключение.',
  rconSelectedPort: 'Выбранный порт',
  rconConfigureCracker: 'Настройте параметры взломщика и нажмите "Взломать порт".',
  rconPortSelected: 'Порт выбран',
  rconScanCompleted: 'Сканирование портов завершено.',
  rconNoPotentialPorts: 'Потенциальные порты RCON не найдены.',
  rconPortScanFinished: 'Сканирование портов завершено (Портов не найдено)',
  rconPortFoundSelectCracker: 'Порт найден, выберите взломщик',
  rconRconAccessGrantedTitle: 'Доступ к RCON предоставлен!',
  rconUsingDefaultPasswordBase: 'Использование базы паролей по умолчанию',
  rconAsNoneSelected: 'так как ни одна не была явно выбрана.',
  rconPortScanInitiated: 'Инициировано сканирование портов...',
  rconPasswordCrackingInitiated: 'Инициирована проверка паролей на порту',
  rconPasswordCrackingInitiatedPort: 'Инициирована проверка паролей (порт не указан в сообщении, текущий:',
  rconPasswordCrackingFinished: 'Проверка паролей завершена на порту',
  rconPasswordNotFound: 'Пароль не найден.',
  rconCrackFinishedFailed: 'Аудит завершен (Неудачно)',
  rconProcessStopped: 'Процесс RCON остановлен.',
  rconPortScanFinishedAwaiting: 'Сканирование портов завершено. Ожидание инициации взлома паролей...',
  rconScanFinishedNoPorts: 'Сканирование портов завершено. Потенциальные порты RCON не найдены.',
  rconPasswordFound: 'Успех! Доступ к RCON предоставлен на порту',
  rconConnectingRcon: 'Подключение к RCON',
  rconAttemptingManualConnect: 'Попытка ручного подключения к RCON',
  rconResettingRconState: 'Сброс состояния RCON',
  rconKeepBaseInfo: 'Сохранить базовую информацию',
  rconStateReset: 'Состояние RCON сброшено',
  rconManualInput: 'Ручной ввод',
  rconConfirmManualInput: 'Подтвердить ручной ввод',
  rconPortScanCompleted: 'Сканирование портов завершено.',
  rconPortsFound: 'Найдены потенциальные порты RCON.',
  rconAwaitingPasswordCrack: 'Ожидание иницииации взлома паролей...',
  rconNeutralAwaiting: 'Нейтральный, ожидание следующего шага',
  rconPortScanFinishedPorts: 'Сканирование портов завершено.',
  rconPotentialRconPort: 'Потенциальный порт RCON найден:',
  rconAvailablePasswordBases: 'Доступные базы паролей загружены:',
  rconFailedLoadPasswordBases: 'Не удалось загрузить базы паролей.',
  rconStatus: 'Статус',
  rconError: 'Ошибка RCON',
  rconCannotConfigure: 'Невозможно настроить взлом RCON. Сначала подключитесь к онлайн-серверу.',
  rconProcessLog: 'Журнал процесса RCON',
  rconClearLog: 'Очистить журнал',
  rconStopProcess: 'Остановить процесс',
  rconStopping: 'Остановка...',
  rconRconProcessLog: 'Журнал процесса RCON',
  rconVipLimitInfo: 'С тарифом VIP доступно только однопоточное сканирование. Если у вас этот тариф - поставьте везде потоки на 1. Многопоточные сканирования доступны только с тарифом Professional.',
  musicVolume: 'Громкость музыки',
  muteMusic: 'Выключить звук',
  unmuteMusic: 'Включить звук',
  musicChoice: 'Выбор музыки',
  statsFor24h: 'За последние 24 часа',
  autoplayBlocked: 'Блокировок автоплея: ',
  musicStayed: 'Слушают музыку',
  avgTimeBeforeMute: 'Слушают в среднем: ',

  // Account Checker
  accountCheckerModuleTitle: 'МОДУЛЬ ПРОВЕРКИ АККАУНТОВ',
  accountCheckerCredentialFinder: 'Чекер аккаунтов',
  accountCheckerDescription: 'Введите имя пользователя Minecraft для поиска соответствующих учетных данных в нашей комплексной базе данных скомпрометированных аккаунтов.',
  accountCheckerPlaceholder: 'Введите имя пользователя Minecraft',
  accountCheckerButton: 'Проверить Аккаунт',
  accountCheckerSearching: 'Поиск...',
  accountCheckerDatabaseSelection: 'Выбор Базы Данных',
  accountCheckerDatabaseAll: 'Все Базы Данных (15.3M аккаунтов)',
  accountCheckerDatabaseRecent: 'Только Недавние Утечки (2.1M аккаунтов)',
  accountCheckerDatabaseVerified: 'Только Проверенные Аккаунты (8.7M аккаунтов)',
  accountCheckerDatabasePremium: 'Доступно',
  accountCheckerSearchType: 'Тип Поиска',
  accountCheckerSearchTypeExact: 'Точное Совпадение',
  accountCheckerSearchTypeSimilar: 'Похожие Имена',
  accountCheckerMaxResults: 'Максимальное Количество Результатов',
  accountCheckerShowConfidence: 'Показать Рейтинг Достоверности',
  accountCheckerTotalAccounts: 'Извлечено данных',
  accountCheckerUniquePasswords: 'Пароли',
  accountCheckerServerSources: 'Источников Серверов',
  accountCheckerSuccessRate: 'Процент Успеха',
  accountCheckerPremiumFeaturesTitle: 'Премиум Функции Проверки Аккаунтов',
  accountCheckerPremiumFeaturesDescription: 'Перейдите на VIP, чтобы получить доступ к расширенным функциям, включая массовую проверку, автоматическую верификацию, проверку электронной почты и многое другое.',
  accountCheckerLearnMore: 'Подробнее',
  accountCheckerUpgradeToVip: 'Перейти на Premium',
  accountCheckerBulkChecking: 'Массовая Проверка',
  accountCheckerBulkCheckingDesc: 'Проверяйте до 1000 аккаунтов одновременно с импортом/экспортом CSV',
  accountCheckerLiveVerification: 'Проверка в Реальном Времени',
  accountCheckerLiveVerificationDesc: 'Автоматически проверяйте аккаунты на серверах Mojang',
  accountCheckerEmailMatching: 'Сопоставление Электронной Почты',
  accountCheckerEmailMatchingDesc: 'Находите связанные адреса электронной почты для полного восстановления аккаунта',
  accountCheckerExtendedDatabase: 'Расширенная База Данных',
  accountCheckerExtendedDatabaseDesc: 'Доступ к нашей премиум базе данных с 7M+ дополнительных аккаунтов',
  accountCheckerHowItWorksTitle: 'Как Это Работает',
  accountCheckerHowItWorksStep1Title: 'Введите Имя Пользователя',
  accountCheckerHowItWorksStep1Desc: 'Введите имя пользователя Minecraft, которое вы хотите проверить.',
  accountCheckerHowItWorksStep2Title: 'Поиск в Базе Данных',
  accountCheckerHowItWorksStep2Desc: 'Мы ищем учетные данные в нашей обширной базе данных утечек.',
  accountCheckerHowItWorksStep3Title: 'Получите Результаты',
  accountCheckerHowItWorksStep3Desc: 'Получите найденные учетные данные и информацию о безопасности.',
  accountCheckerCredentialStuffingTitle: 'Статус Подбора Учетных Данных',
  accountCheckerCredentialStuffingActive: 'Активно',
  accountCheckerCredentialStuffingBotsActive: 'Активных Ботов',
  accountCheckerCredentialStuffingSuccessRate: 'Процент Успеха',
  accountCheckerCredentialStuffingRecentFinds: 'Недавние Находки',
  accountCheckerCredentialStuffingServersMonitored: 'Серверов Под Наблюдением',
  accountCheckerCredentialStuffingActiveProxies: 'Активных Прокси',

  // Credential Stuffing Status
  accountCheckerCredentialStuffingOffline: 'Офлайн',
  accountCheckerCredentialStuffingDescription: 'Продвинутая автономная система ботов, непрерывно тестирующая учетные данные на {{servers}} серверах',
  accountCheckerCredentialStuffingHideDetails: 'Скрыть технические детали',
  accountCheckerCredentialStuffingShowDetails: 'Показать технические детали',
  accountCheckerCredentialStuffingHowItWorks: 'Как это работает',
  accountCheckerCredentialStuffingParsing: 'Парсит популярные сайты мониторинга серверов',
  accountCheckerCredentialStuffingPlayerData: 'Собирает данные об онлайн-игроках',
  accountCheckerCredentialStuffingDeploying: 'Развертывает ботов со случайными учетными данными',
  accountCheckerCredentialStuffingUpdating: 'Обновляет базу данных при успешных попытках',
  accountCheckerCredentialStuffingCurrentActivity: 'Текущая активность',
  accountCheckerCredentialStuffingServersPerHour: 'Серверов/час',
  accountCheckerCredentialStuffingLastUpdate: 'Последнее обновление',
  accountCheckerCredentialStuffingKeyAdvantages: 'Ключевые преимущества',
  accountCheckerCredentialStuffingNoBcrypt: 'Не требуется расшифровка BCrypt',
  accountCheckerCredentialStuffingRealTime: 'Проверка учетных данных в реальном времени',
  accountCheckerCredentialStuffingAutonomous: 'Автономная работа 24/7',
  accountCheckerCredentialStuffingFreshDatabase: 'Интеграция свежей базы данных 2025',
  accountCheckerCredentialStuffingSystemPerformance: 'Производительность системы',
  accountCheckerCredentialStuffingOptimal: 'Оптимальная',

  // Account Results
  accountCheckerPasswordHashesDetected: 'Обнаружены Хэши Паролей',
  accountCheckerPasswordHashesDetectedDesc: 'Некоторые пароли отображаются в виде хэшей (например, sha$5, md5:abcdef). Это зашифрованные пароли, которые необходимо расшифровать.',
  accountCheckerDecryptHashes: 'Расшифровать хэши на hashes.com',
  accountCheckerDismiss: 'Закрыть',
  accountCheckerSearchError: 'Ошибка Поиска',
  accountCheckerTryAnotherSearch: 'Попробовать Другой Поиск',
  accountCheckerSearchingFor: 'Поиск',
  accountCheckerNoResultsFound: 'Результаты не найдены для',
  accountCheckerTryDifferentUsername: 'Попробуйте другое имя пользователя или измените параметры поиска',
  accountCheckerEnterUsername: 'Введите имя пользователя для начала поиска',
  accountCheckerPopularSearches: 'Популярные поисковые запросы:',
  accountCheckerConfidence: 'Уровень Достоверности',
  accountCheckerHashedPassword: 'Это хэшированный пароль',
  accountCheckerHash: 'Хэш',
  accountCheckerCopyCredentials: 'Копировать Учетные Данные',
  accountCheckerSource: 'Источник',
  accountCheckerLastVerified: 'Последняя Проверка',
  accountCheckerPreparingResults: 'Подготовка области результатов поиска...',
  accountCheckerSearchResults: 'Результаты Поиска Аккаунтов',
  accountCheckerMatchesFound: 'совпадений найдено',
  accountCheckerError: 'Ошибка',
  accountCheckerExportResults: 'Экспорт Результатов',
  accountCheckerNewSearch: 'Новый Поиск',

  // Search History
  accountCheckerRecentSearches: 'Недавние Поиски',
  accountCheckerNoRecentSearches: 'Нет недавних поисков',
  accountCheckerResults: 'результатов',
  accountCheckerViewFullHistory: 'Просмотреть Полную Историю',

  // Account Checker Page
  accountCheckerError: 'Ошибка проверки аккаунта',
  accountCheckerModuleName: 'Проверка аккаунтов',
  accountCheckerNoResultsFound: 'Результаты не найдены для',
  accountCheckerFailedLoadHistory: 'Не удалось загрузить историю поиска',
  accountCheckerConnectionLost: 'Соединение потеряно во время поиска',
  accountCheckerEnterUsernameError: 'Пожалуйста, введите имя пользователя',
  accountCheckerLoginRequired: 'Пожалуйста, войдите, чтобы выполнить поиск',
  accountCheckerNotConnected: 'Нет подключения к серверу. Пожалуйста, подождите или обновите страницу',
  accountCheckerSearchComplete: 'Поиск завершен. Найдено',
  accountCheckerResult: 'результат',

  // Common terms
  accountCheckerSearching: 'Поиск',

  // Server Database
  serverDatabase: 'Серверы',
  availableServers: 'Доступные серверы',
  serverDatabaseDescription: 'Просматривайте нашу базу данных доступных серверов для тестирования с мгновенным подключением. Обновляется каждые 30 минут.',
  refreshList: 'Обновить список',
  allServers: 'Все серверы',
  online: 'Онлайн',
  popular: 'Популярные',
  vulnerable: 'Уязвимые',
  moreFilters: 'Дополнительные фильтры',
  gridView: 'Вид сеткой',
  listView: 'Вид списком',
  searchServers: 'Поиск серверов по IP, названию или тегу...',
  version: 'Версия',
  anyVersion: 'Любая версия',
  playerCount: 'Количество игроков',
  anySize: 'Любой размер',
  small: 'Маленький (0-100)',
  medium: 'Средний (101-1000)',
  large: 'Большой (1000+)',
  lastTested: 'Последнее тестирование',
  anyTime: 'Любое время',
  lastHour: 'Последний час',
  last24Hours: 'Последние 24 часа',
  last7Days: 'Последние 7 дней',
  last30Days: 'Последние 30 дней',
  noServersFound: 'Серверы, соответствующие вашим критериям, не найдены',
  server: 'Сервер',
  players: 'Игроки',
  status: 'Статус',
  actions: 'Действия',
  test: 'Тест',
  connect: 'Подключиться',
  protected: 'Защищенный',
  mediumRisk: 'Средний риск',
  ipAddress: 'IP:',
  successRate: 'Уровень успеха:',
  lastUpdate: 'Последнее обновление',
  hoveredServer: 'Наведенный сервер',
  unlockPremium: 'Разблокировать Professional',
  premiumDatabaseDescription: 'Получите доступ к нашей расширенной базе данных с более чем 10 000+ уязвимыми серверами Minecraft и расширенными возможностями фильтрации.',
  upgradeToPremium: 'Перейти на Professional',
  additionalServers: 'Дополнительные серверы',

  // Server Data Extraction
  serverDataExtractionModule: 'МОДУЛЬ ИЗВЛЕЧЕНИЯ ДАННЫХ СЕРВЕРА',
  retrieveServerData: 'Выкачивание данных сервера',
  serverDataExtractionDescription: 'Подключитесь к целевому серверу ниже, чтобы получить доступные данные, такие как MOTD, списки игроков, плагины и многое другое.',
  extractionOptions: 'Параметры извлечения',
  serverInformation: 'Информация о сервере',
  basicServerInfo: 'Базовая информация о сервере, IP, версия, статус',
  messageOfTheDay: 'Сообщение дня',
  motdWithFormatting: 'Сообщение дня с форматированием',
  serverIcon: 'Иконка сервера',
  downloadServerIcon: 'Скачать иконку сервера (64x64)',
  playerList: 'Список игроков',
  onlinePlayersNames: 'Онлайн игроки с именами, если доступны',
  pluginList: 'Список плагинов',
  detectServerPlugins: 'Обнаружить плагины сервера, если они открыты',
  deepScan: 'Глубокое сканирование',
  tryAdvancedMethods: 'Попробовать продвинутые методы для извлечения большего количества данных',
  methodTimeout: 'Таймаут метода (мс)',
  adjustScanSpeed: 'Настроить скорость сканирования',
  outputFormat: 'Формат вывода',
  chooseReportType: 'Выбрать тип отчета',
  extractServerData: 'Извлечь данные сервера',
  extracting: 'Извлечение...',
  extractedData: 'Извлеченные данные',
  extractData: 'Извлечь данные',
  dataExtractionHistory: 'История извлечения данных',
  errorLoadingHistory: 'Ошибка загрузки истории',
  noExtractionHistory: 'История извлечения данных отсутствует',
  serverDataExtractionTips: 'Советы по извлечению данных сервера',
  playerSampling: 'Выборка игроков',
  playerSamplingDescription: 'Многие серверы отправляют только выборку онлайн-игроков. Глубокое сканирование может показать больше.',
  pluginDetection: 'Обнаружение плагинов',
  pluginDetectionDescription: 'Списки плагинов часто скрыты. Успех зависит от конфигурации сервера.',
  timeoutSettings: 'Настройки таймаута',
  timeoutSettingsDescription: 'Увеличьте таймаут для медленных серверов, но будьте осторожны с флагами безопасности.',
  dataExtractionError: 'Ошибка извлечения данных',
  dataExtractionCompleted: 'Извлечение данных завершено',
  dataExtractionFailed: 'Извлечение данных не удалось',
  dataExtractionInProgress: 'Извлечение данных в процессе',
  download: 'Скачать',
  copy: 'Копировать',
  copyRaw: 'Копировать исходный код',
  serverIconTitle: 'Иконка сервера',
  serverInformationTitle: 'Информация о сервере',
  playerListTitle: 'Список игроков',
  pluginListTitle: 'Список плагинов',
  motdTitle: 'Сообщение дня',
  rawData: 'Исходные данные',
  rawDataJson: 'Исходные данные (JSON)',
  downloadAllData: 'Скачать все данные (JSON)',
  errorLoadingPlayers: 'Ошибка загрузки игроков',
  noPlayerData: 'Нет данных об игроках',
  errorLoadingPlugins: 'Ошибка загрузки плагинов',
  noPluginsDetected: 'Плагины не обнаружены',
  errorLoadingMotd: 'Ошибка загрузки MOTD',
  motdNotAvailable: 'MOTD недоступен',
  noDataAvailable: 'Данные недоступны',
  connectToServerToViewData: 'Подключитесь к серверу для просмотра извлеченных данных.',
  pleaseWait: 'Пожалуйста, подождите.',
  extractDataFirst: 'Сначала извлеките данные сервера.',
  errorLoadingIcon: 'Ошибка загрузки иконки',
  iconNotAvailable: 'Иконка недоступна',
  ipAddressLabel: 'IP адрес',
  port: 'Порт',
  status: 'Статус',
  version: 'Версия',
  playersOnline: 'Игроков онлайн',
  ping: 'Пинг',
  onlinePlayers: 'Онлайн игроки',
  pluginListDetected: 'обнаружено',
  motd: 'MOTD',
  raw: 'Исходный код',
  info: 'Информация',
  icon: 'Иконка',
  players: 'Игроки',
  plugins: 'Плагины',
  motdTab: 'MOTD',
  rawTab: 'Исходный код',
  extract: 'Извлечь',
  extractingData: 'Извлечение данных...',
  extractionSuccess: 'Успех',
  extractionPartial: 'Частично',
  extractionError: 'Ошибка',
  extractionComplete: 'Завершено',
  serverOnline: 'Онлайн',
  serverOffline: 'Офлайн',
  serverError: 'Ошибка',
  copyAll: 'Копировать все',
  downloadAll: 'Скачать все',
  noHistoryAvailable: 'История извлечения данных отсутствует',
  errorLoadingHistoryText: 'Ошибка загрузки истории извлечения данных',
  data: 'Данные',
  idle: 'Бездействие',
  extractedData: 'Извлеченные данные',
  date: 'Дата',

  // Bot Connection
  botConnectionModule: 'МОДУЛЬ ПОДКЛЮЧЕНИЯ БОТОВ',
  botConnectionDescription: 'Подключитесь к целевому серверу ниже, чтобы подготовиться к развертыванию бота. Основная информация о сервере будет проверена при подключении.',
  botSelection: 'Выбор бота',
  botTypesAvailable: 'доступно 3 типа',
  botSelectionNone: 'Нет доступных типов ботов',
  botSelectionNoTypes: 'Нет типов ботов',
  botNameOpBot: 'OP Бот',
  botNameCrashBot: 'Краш Бот',
  botNameAccountBot: 'Аккаунт Бот',
  botDescriptionOpBot: 'Получить права оператора',
  botDescriptionCrashBot: 'Проверить стабильность сервера',
  botDescriptionAccountBot: 'Найти пароли аккаунтов',
  botSuccessRate: 'Уровень успеха:',
  botConfiguration: 'Конфигурация',
  botUsername: 'Имя пользователя бота',
  botUsernameRandom: 'Случайное имя пользователя',
  botUsernameCustom: 'Пользовательское имя',
  botUsernamePremium: 'Премиум аккаунт',
  botEnterCustomUsername: 'Введите пользовательское имя',
  botEnterDesiredUsername: 'Введите желаемое имя пользователя',
  botTargetUsername: 'Целевое имя пользователя',
  botEnterTargetUsername: 'Введите имя целевого аккаунта',
  botAttackMethod: 'Метод атаки',
  botAttackMethodConsole: 'Эксплойт консольных команд',
  botAttackMethodPlugin: 'Уязвимости плагинов',
  botAttackMethodSocial: 'Социальная инженерия',
  botAttackMethodPermission: 'Эксплойты разрешений',
  botAttackMethodAll: 'Попробовать все методы',
  botSkin: 'Скин бота',
  botVersion: 'Версия Minecraft',
  botVersionAuto: 'Автоопределение',
  botBehavior: 'Поведение бота',
  botBehaviorStealth: 'Режим скрытности (низкая вероятность обнаружения)',
  botBehaviorAggressive: 'Агрессивный режим (быстрая атака)',
  botBehaviorMixed: 'Смешанный режим (сбалансированный)',
  botAntiBotBypass: 'Метод обхода анти-бота',
  botAntiBotBypassNone: 'Нет (по умолчанию)',
  botAntiBotBypassStealth: 'Базовые тактики скрытности',
  botAntiBotBypassProxy: 'Ротация прокси',
  botAntiBotBypassHuman: 'Эмуляция поведения человека',
  botAntiBotBypassAdvanced: 'Продвинутый протокол уклонения',
  botAttempts: 'Количество попыток',
  botDeployButton: 'Развернуть {{botName}}',
  botDeploying: 'Развертывание...',
  botDeploymentConsole: 'Консоль развертывания',
  botOpCommandCenter: 'Центр команд оператора',
  botOpRequired: 'Заблокировано - требуется OP',
  botOpAddAdmin: 'Добавить администратора',
  botOpAddAdminDesc: 'Добавить свой аккаунт в качестве администратора сервера',
  botOpExtractData: 'Извлечь данные',
  botOpExtractDataDesc: 'Извлечь данные игроков, конфигурации и базы данных',
  botOpInstallBackdoor: 'Установить бэкдор',
  botOpInstallBackdoorDesc: 'Установить постоянный доступ к серверу',
  botOpExecute: 'Выполнить',
  botOpAccessRequired: 'Требуется доступ OP',
  botStrategyTips: 'Советы по стратегии ботов',
  botStrategyTipsPro: 'Профессиональные советы',
  botStrategyTip1: 'Избегайте обнаружения',
  botStrategyTip1Desc: 'Используйте режим скрытности и избегайте быстрых команд. Большинство анти-бот плагинов обнаруживают необычные паттерны поведения. Распределяйте свои попытки для лучшего результата.',
  botStrategyTip2: 'Нацеливайтесь на уязвимости',
  botStrategyTip2Desc: 'Старые версии серверов (1.8-1.12) более уязвимы к эксплойтам консольных команд. Проверьте версию сервера перед развертыванием.',
  botStrategyTip3: 'Чередуйтесь методы',
  botStrategyTip3Desc: 'Если один метод не работает, попробуйте другие методы эксплойта. Распространенные уязвимости плагинов включают Essentials, PermissionsEx и ошибки конфигурации LuckPerms.',
  botPremiumFeatures: 'Professional функции ботов',
  botPremiumFeaturesVip: 'Только для VIP',
  botPremiumFeature1: 'Продвинутые OP эксплойты',
  botPremiumFeature1Desc: 'Премиум пользователи получают доступ к продвинутым эксплойтам, нацеленным на специфические плагины сервера и уязвимые системы разрешений.',
  botPremiumFeature2: 'Множественное развертывание ботов',
  botPremiumFeature2Desc: 'Развертывайте несколько ботов одновременно с разными стратегиями для драматического увеличения уровня успеха.',
  botPremiumFeature3: 'Незаметный режим',
  botPremiumFeature3Desc: 'Professional боты используют продвинутые техники для избежания обнаружения популярными анти-бот плагинами.',
  botUpgradeToPremium: 'Перейти на Professional',
  botDeploymentHistory: 'История развертывания ботов',
  botDeploymentHistoryLoading: 'Загрузка истории...',
  botDeploymentHistoryError: 'Ошибка загрузки истории:',
  botDeploymentHistoryEmpty: 'Нет доступной истории развертывания',
  botDeploymentHistoryRecords: '{{count}} записей',
  botDeploymentDate: 'Дата и время',
  botDeploymentServer: 'Сервер',
  botDeploymentType: 'Тип бота',
  botDeploymentResult: 'Результат',
  botDeploymentActions: 'Действия',
  botDeploymentViewLog: 'Просмотр лога',
  botDeploymentOpBot: 'OP Бот',
  botDeploymentCrashBot: 'Краш Бот',
  botDeploymentAccountBot: 'Аккаунт Бот',

  // Common terms
  status: 'Статус',
  connection: 'Подключение',
  active: 'Активно',
  ready: 'Готов',
  waiting: 'Ожидание',
  achieved: 'Достигнуто',
  trying: 'Попытка',
  save: 'Сохранить',
  stop: 'Остановить',
  copiedToClipboard: 'Скопировано в буфер обмена!',
  failedToCopyLog: 'Не удалось скопировать лог.',
  bots: 'Боты',

  // Payment Modal
  selectPaymentMethod: 'Выберите способ оплаты',
  initiatingPayment: 'Инициация платежа...',
  awaitingPaymentConfirmation: 'Ожидание подтверждения платежа',
  paymentError: 'Ошибка оплаты',
  paymentSuccessful: 'Платеж успешен',
  payment: 'Оплата',
  renew: 'Продлить',
  plan: 'План',
  upgradeTo: 'Перейти на',
  currentPlan: 'Текущий план',
  paymentConfirmed: 'Платеж подтвержден!',
  your: 'Ваш',
  planIsActive: 'план теперь активен.',
  joinOurCommunity: 'Присоединяйтесь к нашему сообществу для обновлений и поддержки!',
  stayUpdated: 'Будьте в курсе последних функций и получайте помощь от нашей команды',
  done: 'Готово',
  securePaymentGateway: 'Безопасный платежный шлюз',
  noPaymentMethodsAvailable: 'Нет доступных способов оплаты.',
  byProceedingWithPayment: 'Продолжая оплату, вы соглашаетесь с нашими',
  confirmWith: 'Подтвердить с',
  selectedMethod: 'Выбранный способ',
  preparingYourPayment: 'Подготовка вашего платежа...',
  pleaseWaitWhileWeConnect: 'Пожалуйста, подождите, пока мы подключимся к платежному провайдеру.',
  waitingForPaymentConfirmation: 'Ожидание подтверждения платежа',
  yourPaymentPageShouldHaveOpened: 'Страница оплаты должна была открыться в новой вкладке. Это окно обновится автоматически после подтверждения.',
  reopenPaymentPage: 'Открыть страницу оплаты снова',
  needHelpContactUs: 'Нужна помощь? Свяжитесь с нами:',
  anUnexpectedErrorOccurred: 'Произошла неожиданная ошибка.',

  // Zero Day Method
  zeroDayMethodModule: 'МОДУЛЬ МЕТОДА ZERO-DAY',
  zeroDayMethodTitle: 'Проприетарный',
  zeroDayMethodDescription: 'Наш передовой проприетарный метод использует недоступные эксплойты zero-day с 78% процентом успеха на уязвимых серверах. Этот метод постоянно обновляется, чтобы опережать патчи безопасности.',
  zeroDayPremiumExclusive: 'ЭКСКЛЮЗИВНО ДЛЯ PROFESSIONAL',
  zeroDayUndetectable: 'Невидимый',
  zeroDayFastExecution: 'Быстрое Выполнение',
  zeroDayFullAccess: 'Полный Доступ',
  zeroDayWeeklyUpdates: 'Еженедельные Обновления',
  zeroDayAiConfiguration: 'Конфигурация ИИ',
  zeroDayAiAnalysisDepth: 'Глубина Анализа ИИ',
  zeroDayBasic: 'Базовый',
  zeroDayStandard: 'Стандартный',
  zeroDayDeep: 'Глубокий',
  zeroDayAnalysisFocus: 'Фокус Анализа',
  zeroDayBalancedAnalysis: 'Сбалансированный Анализ',
  zeroDayPluginVulnerabilities: 'Уязвимости Плагинов',
  zeroDayConfigurationIssues: 'Проблемы Конфигурации',
  zeroDayNetworkSecurity: 'Безопасность Сети',
  zeroDayAuthenticationSystems: 'Системы Аутентификации',
  zeroDayAiModel: 'Модель ИИ',
  zeroDayConnectionType: 'Тип Подключения',
  zeroDayDirectConnection: 'Прямое Подключение',
  zeroDayProxyChain: 'Через Цепочку Прокси',
  zeroDayVpnConnection: 'VPN Подключение',
  zeroDayStealthMode: 'Режим Скрытности',
  zeroDayAiPerformance: 'Производительность ИИ',
  zeroDaySuccessRate: 'Процент Успеха',
  zeroDayDetectionRisk: 'Риск Обнаружения',
  zeroDayAvgAnalysisTime: 'Среднее Время Анализа',
  zeroDayModelVersion: 'Версия Модели',
  zeroDayCapabilities: 'Возможности',
  zeroDayPluginAnalysis: 'Анализ Плагинов',
  zeroDayConfigScanning: 'Сканирование Конфигураций',
  zeroDayVersionDetection: 'Обнаружение Версий',
  zeroDayExploitMatching: 'Сопоставление Эксплойтов',
  zeroDayAdaptiveLearning: 'Адаптивное Обучение',
  zeroDayReportGeneration: 'Генерация Отчетов',
  zeroDayNetworkPathAnalysis: 'Анализ Сетевых Путей',
  zeroDayUserBehaviorSimulation: 'Симуляция Поведения Пользователя',
  zeroDayAiProgress: 'Прогресс ИИ',
  zeroDayOverallProgress: 'Общий Прогресс',
  zeroDayCurrentTask: 'Текущая Задача',
  zeroDayAwaitingInitialization: 'Ожидание Инициализации',
  zeroDayConnectToServer: 'Подключитесь к серверу и начните анализ.',
  zeroDayReadyForAnalysis: 'Готов к Анализу',
  zeroDayConfigureAi: 'Настройте ИИ и начните процесс.',
  zeroDayAiOperationLog: 'Журнал Операций ИИ Zero-Day',
  zeroDayStartChat: 'Старт',
  zeroDayHello: 'Привет',
  zeroDayAiThinking: 'ИИ думает...',
  zeroDayStopOrAsk: 'Остановить или спросить',
  zeroDayInputPlaceholder: 'Любое сообщение. Например "Продолжи"...',
  zeroDayStopAnalysis: 'Остановить Анализ',
  zeroDayStartAiAnalysis: 'Начать Анализ ИИ',
  zeroDayStopping: 'Остановка...',
  zeroDayInitiating: 'Инициация...',
  zeroDayAnalysisComplete: 'Анализ Завершен',
  zeroDayAiAchievedRconAccess: 'ИИ Достиг Доступа RCON!',
  zeroDayLiveControl: 'Живое Управление',
  zeroDayRconSuccessMessage: 'ИИ Zero-Day успешно получил доступ RCON к',
  zeroDayConsoleNowActive: 'Консоль выше теперь активна для выполнения команд.',
  zeroDayViewFullReport: 'Просмотреть Полный Отчет',
  zeroDayAiReport: 'Отчет ИИ Zero-Day',
  zeroDayOverallAssessment: 'Общая Оценка',
  zeroDayTargetServer: 'Целевой Сервер',
  zeroDayAnalysisReport: 'Отчет Анализа',
  zeroDayVulnerabilitiesFound: 'Найденные Уязвимости',
  zeroDayExploitationPaths: 'Пути Эксплуатации',
  zeroDayRiskLevel: 'Уровень Риска',
  zeroDayRecommendations: 'Рекомендации',
  zeroDayCritical: 'Критический',
  zeroDayHigh: 'Высокий',
  zeroDayMedium: 'Средний',
  zeroDayLow: 'Низкий',
  zeroDayInformational: 'Информационный',
  zeroDayClose: 'Закрыть',
  zeroDayExportReport: 'Экспортировать Отчет',
  zeroDayRconActive: 'RCON Активен',
  zeroDayCompletedReport: 'Отчет Завершен',
  zeroDayError: 'Ошибка',
  zeroDayConfiguringAi: 'Настройка ИИ',
  zeroDayIdle: 'Бездействие',
  zeroDayAnalyzing: 'Анализ',
  zeroDayStoppingAnalysis: 'Остановка Анализа',
  zeroDayReadyToAnalyze: 'Готов к анализу.',
  zeroDayAiAnalysisInitiated: 'Инициирован анализ ИИ...',
  zeroDayCannotStartNotConnected: 'Невозможно начать: Не подключено к целевому серверу.',
  zeroDayCannotStartAlreadyRunning: 'Невозможно начать: Операция ИИ уже выполняется.',
  zeroDayCannotStopNotRunning: 'Невозможно остановить: Нет запущенного анализа или WebSocket отключен.',
  zeroDayRconNotActive: 'RCON не активен.',
  zeroDayWebSocketNotConnected: 'WebSocket не подключен. Пожалуйста, подождите или обновите страницу.',
  zeroDayServerNotConnected: 'Сервер не подключен или находится офлайн.',
  zeroDayOperationInterrupted: 'Соединение WebSocket потеряно. Текущая операция может быть прервана. Попытка восстановить состояние...',
  zeroDayStateReceivedNoOperation: 'Состояние получено: Нет активной операции ИИ. Готов к настройке для',
  zeroDayStateReceivedNoServer: 'Состояние обновления: Не подключено ни к одному серверу для ИИ ZeroDay.',
  zeroDayReconnectedToRcon: 'Повторное подключение к активной сессии RCON.',
  zeroDayReconnectedToAnalysis: 'Повторное подключение к текущему анализу ИИ.',
  zeroDayProgressDataMissing: 'Данные о прогрессе отсутствуют в CURRENT_STATE от бэкенда для активной операции. Ожидание следующего обновления.',
  zeroDayReportSummary: 'Сводка Отчета',
  zeroDayRconAccessGranted: 'Доступ RCON Предоставлен',
  zeroDayReportGenerated: 'Отчет сгенерирован.',
  zeroDayInitializingAi: 'Инициализация ядра анализа...',
  zeroDayInitiatingDeepScan: 'Инициация глубокого сканирования...',
  zeroDayOperationStatus: 'Статус Операции',
  zeroDayUnknownErrorStructure: 'Неизвестная структура ошибки ZeroDay.',
  zeroDayErrorOccurred: 'Произошла Ошибка',
  zeroDayConnectToServerForAnalysis: 'Подключитесь к серверу для анализа.',
  zeroDayReadyForAiAnalysis: 'Готов для анализа ИИ.',
  zeroDayAiActive: 'ИИ Активен',
  zeroDayBetaNotice: 'Это Beta-версия ZeroDay Assist. Мы постоянно работаем над улучшением алгоритмов.',
  zeroDayPossibleErrors: 'Могут быть ошибки',
  zeroDayReportBug: 'Нашли ошибку?',
  zeroDayQueueTitle: 'Лимит бета-теста',
  zeroDayQueueDesc: 'В данный момент ИИ использует много человек. Для соблюдения стабильности во время бета-теста, доступ ограничен. Пожалуйста, подождите 5-10 минут, пока слот освободится.',

  // Server Info Card
  serverAlreadyBlacklisted: 'Этот сервер уже находится в черном списке',
  serverInfoEnterIp: 'Введите IP сервера для подключения',
  serverInfoIpPlaceholder: 'Введите IP сервера (например, play.hypixel.net:25565)',
  serverInfoConnect: 'Подключиться к серверу',
  serverInfoLoginToConnect: 'Войдите, чтобы подключиться',
  serverInfoDisconnect: 'Отключиться',
  serverInfoOnline: 'Онлайн',
  serverInfoOffline: 'Офлайн',
  serverInfoMotd: 'Сообщение дня',
  serverBlacklisted: 'Сервер в черном списке',
  serverBlacklistedDesc: 'Этот сервер был добавлен в черный список и не может быть протестирован.',
  reason: 'Причина',

  // Server Protection Component
  serverProtection: "Защита сервера",
  protectYourServer: 'Защитите свой сервер от несанкционированного доступа',
  serverIpAddress: 'IP-адрес сервера',
  addToBlacklist: 'Добавить в черный список',
  loginToProtect: 'Войдите, чтобы защитить',
  adding: 'Добавление...',
  successTitle: 'Успех!',
  serverProtected: 'Ваш сервер был добавлен в список защиты',
  whyProtectServer: 'Зачем защищать свой сервер?',
  protectionDescription: 'Добавление вашего сервера в наш черный список предотвращает использование наших инструментов против него. Это особенно важно для серверов, которыми вы владеете или управляете.',
  pleaseEnterServerIp: 'Пожалуйста, введите IP-адрес сервера',
  failedToAddServer: 'Не удалось добавить сервер в черный список',
  serverAlreadyBlacklisted: 'Этот сервер уже находится в черном списке',

  partner: "Anchor Studio",
  partnerName: "Кастомные сборки, плагины, игры, текстуры, скины, аддоны",
  anchorStudioDesc: "Нажмите, чтобы чтобы узнать больше!",

  // Monitoring Parser
  parserModuleTitle: 'МОДУЛЬ ПАРСЕРА СЕРВЕРОВ',
  parserMonitoring: 'Парсер',
  parserParser: 'Серверов',
  parserDescription: 'Анализируйте популярные сайты мониторинга серверов для поиска уязвимых серверов или серверов с определенными параметрами.',
  parserConfiguration: 'Конфигурация',
  parserSearchType: 'Тип поиска',
  parserByVulnerability: 'По уязвимости',
  parserByParameters: 'По параметрам',
  parserVulnerabilityLevel: 'Уровень уязвимости',
  parserLowVulnerability: 'Низкая уязвимость',
  parserMediumVulnerability: 'Средняя уязвимость',
  parserHighVulnerability: 'Высокая уязвимость',
  parserLowVulnDesc: 'Серверы с предположительно базовыми уязвимостями',
  parserMediumVulnDesc: 'Серверы с предположительно средними уязвимостями',
  parserHighVulnDesc: 'Серверы с предположительно критическими уязвимостями (тариф VIP и выше)',
  parserOnlinePlayersRange: 'Диапазон онлайн-игроков',
  parserMin: 'Мин',
  parserMax: 'Макс',
  parserVersionFilter: 'Фильтр версий',
  parserVersionPlaceholder: '1.12.2, 1.16.5 и т.д.',
  parserVersionHint: 'Оставьте пустым для всех версий',
  parserServerCount: 'Количество серверов',
  parserServersFound: 'серверов найдено',
  parserStartParsing: 'Начать парсинг',
  parserStopParsing: 'Остановить парсинг',
  parserParsing: 'Парсинг...',
  parserProcessLog: 'Журнал процесса парсера',
  parserClearLog: 'Очистить журнал',
  parserExport: 'Экспорт',
  parserFoundServers: 'Найденные серверы',
  parserResults: 'результатов',
  parserSelectAll: 'Выбрать все',
  parserDeselectAll: 'Отменить выбор',
  parserSelect: 'Выбрать',
  parserServerIP: 'IP сервера',
  parserVersion: 'Версия',
  parserOnline: 'Онлайн',
  parserVulnerability: 'Уязвимость',
  parserActions: 'Действия',
  parserCopy: 'Копировать',
  parserViewDetails: 'Просмотреть детали',
  parserMOTD: 'Сообщение дня',
  parserFoundAt: 'Найден в',
  parserFavicon: 'Иконка',
  parserNoServersYet: 'Серверы еще не найдены',
  parserTips: 'Советы по парсингу',
  parserSearchStrategies: 'Стратегии поиска',
  parserSearchStrategiesTip: 'Поиск по уязвимости находит серверы с известными проблемами безопасности, в то время как поиск по параметрам позволяет находить серверы с определенными характеристиками.',
  parserVulnerabilityLevels: 'Уровни уязвимости',
  parserVulnerabilityLevelsTip: 'Низкий уровень находит серверы с базовыми уязвимостями, средний - с более серьезными проблемами, а высокий - с критическими уязвимостями.',
  parserUseFilters: 'Используйте фильтры',
  parserUseFiltersTip: 'Фильтры по количеству игроков и версии сервера помогают сузить поиск до нужных вам серверов.',
  parserServerFound: 'Найден сервер',
  parserParsingStarted: 'Парсинг начат',
  parserSearching: 'Поиск',
  parserParsingCompleted: 'Парсинг завершен',
  parserFound: 'Найдено',
  parserCompleted: 'Завершено',
  parserParsingStopped: 'Парсинг остановлен',
  parserStopped: 'Остановлен',
  parserError: 'Ошибка парсера',
  parserWebSocketNotConnected: 'WebSocket не подключен. Пожалуйста, подождите или обновите страницу.',
  parserConnectionError: 'Ошибка подключения',
  parserAlreadyRunning: 'Парсер уже запущен',
  parserInitiating: 'Инициация',
  parserNoActiveProcess: 'Нет активного процесса',
  parserStoppingProcess: 'Остановка процесса',
  parserStopping: 'Остановка',
  parserNoData: 'Нет данных',
  parserNoServersToExport: 'Нет серверов для экспорта',
  parserExportSuccess: 'Экспорт успешен',
  parserExported: 'Экспортировано',

  monitoringParser: "Парсер серверов",
  parserShort: "Парсер",
  monitoringParserDescription: "Автоматический поиск серверов из мониторингов по параметрам уязвимости и онлайна",
  parserMonitorings: "Мониторингов",
  parserServersAvailable: "Серверов доступно",

  // Parser Promo Banner
  parserNewFeature: '🎉 Новая функция',
  parserPromoTitle: 'Попробуйте наш новый',
  parserPromoTitleHighlight: 'Servers Parser',
  parserPromoDescription: 'Автоматически находите уязвимые серверы из 50+ мониторингов. Более 100 000 серверов доступно для анализа!',
  parserPromoFeature1: '50+ мониторингов',
  parserPromoFeature2: '100K+ серверов',
  parserPromoFeature3: 'Авто-фильтрация',
  parserPromoButton: 'Попробовать бесплатно',
  parserMonitorings: 'мониторингов',
  parserServers: 'серверов',

  autumnSale: "Осенние скидки",
  newYearSale: "Новогодние скидки",
  saleEndsIn: "Рождество через",
  days: "Дней",
  hours: "Часов",
  min: "Мин",
  sec: "Сек",
  withAutumnDiscount: "с осенней скидкой",
  withNewYearDiscount: "с новогодней скидкой",
  discount: "Скидка",
  unlimitedAccess: "Безлимитный доступ",
  prioritySupport: "Приоритетная поддержка",
  advancedTools: "Продвинутые инструменты",
  specialSale: "Специальная распродажа",
  winterSale: "Зимняя распродажа",
  summerSale: "Летняя распродажа",
  springSale: "Весенняя распродажа",
  blackFridaySale: "Черная пятница",
  cyberMondaySale: "Киберпонедельник",

  // Delayed Support Message
  supportMessageTitle: 'Задержки или сложности?',
  supportMessageText: 'Напишите нам',
  supportMessageDescription: 'Если у вас возникли проблемы с оплатой или есть вопросы, наша команда поддержки готова помочь.',


  otherPaymentMethods: 'Другие способы оплаты',
  cryptoBankEtc: 'Если вдруг эти не подошли',
  otherPaymentMethodsDescription: 'Свяжитесь с нашей поддержкой для использования альтернативных методов оплаты',
  contactViaDiscord: 'Связаться через Discord',
  contactViaTelegram: 'Связаться через Telegram',
  alternativePaymentInfo: 'Мы поддерживаем различные способы оплаты',
  cryptoCurrency: 'Криптовалюта',
  bankTransfer: 'Банковский перевод',
  otherMethods: 'Другие методы',
  backToPaymentMethods: 'Назад к методам оплаты',
  // Maintenance Modal
  maintenanceMode: 'Режим обслуживания',
  methodAvailableSoon: 'Метод скоро будет доступен',
  maintenanceDescription: 'Эта функция проходит плановое обслуживание для улучшения производительности и стабильности.',
  expected: 'Ожидается',
  thisMonth: 'В этом месяце',
  status: 'Статус',
  updating: 'Обновление',
  stayUpdated: 'Следите за обновлениями в наших каналах',
  understood: 'Понятно',
  botCommandHelpTitle: 'Когда бот окажется в лобби, введите команду:',
  botCommandHelpGoto: '- "goto <мир>" (напр. goto Выживание) для перехода из лобби на какой-то другой сервер',
  botCommandHelpStart: '- "start" для начала работы способа',

  // Modals & Reminders
  upsellRequired: 'Требуется обновление тарифа',
  featureRequiresPlan: '**Мы бы рады предоставить вам эту функцию бесплатно, но из-за необходимости оплачивать работу...** Эта функция требует тариф {{plan}} или выше. Это не займёт много времени, обновление подписки для доступа к этому инструменту занимает в среднем 3 минуты.',
  upgradePlan: 'Обновить тариф',
  premiumFeature: 'Премиум функция',
  secretMethodExclusive: 'Zero-day метод доступен эксклюзивно для пользователей с тарифом Premium и VIP. Обновите тариф, чтобы разблокировать самый мощный инструмент в нашем арсенале.',
  upgradeToVipForAll: 'Перейти на VIP для всех функций',

  'perm_module_rconbrute': 'Доступ к RCON аудиту',
  'perm_module_rconbrute_speed': 'Многопоточное сканирование RCON. Если у вас тариф Vip - выставите в Конфигурации портов и Конфигурации паролей потоки на 1',
  'perm_permission_rcon_speed': 'Повышенная скорость RCON сканирования',
  'perm_module_parser_high': 'Доступ к критическим уязвимостям в парсере',
  'perm_module_accountchecker': 'Использование чекера аккаунтов',

  // AI Assistant
  aiAssistantTitle: 'Хакер со стажем',
  aiAssistantWelcome: 'Зашел по адресу. Меня наняли специально, чтобы разгребать твои затыки с пентестом. Что на повестке? RCON, DDoS или сразу Zero-day?',
  aiAssistantInvite: 'Нужна помощь с аудитом сервера? Я помогу подобрать нужный инструмент!',
  aiAssistantConnecting: 'Подключение к нейросети...',
  aiAssistantError: 'Ошибка связи с ИИ. Попробуйте позже.',
  aiAssistantInsufficientPlan: 'Ваш текущий план не поддерживает использование ИИ-помощника.',
  aiAssistantLoginRequired: 'Пожалуйста, войдите в аккаунт, чтобы использовать ИИ-помощника.',
  ERROR_RATE_LIMIT_EXCEEDED: 'Лимит запросов превышен (10/мин). Пожалуйста, подождите.',
  ERROR_AI_BANNED: 'Ваш аккаунт временно заблокирован в AI-модуле за спам запросами.',
  ERROR_AI_SERVICE_UNAVAILABLE: 'Сервис AI временно недоступен.',

  // New Feature Modal
  newFeatureTitle: 'ZERO-DAY МЕТОД ВЫШЕЛ',
  newFeatureDescription: 'Теперь фиксировать критические уязвимости в Minecraft может специальный ИИ. Новый проприетарный метод Zero-Day стал доступен. Анализ уязвимостей теперь автоматизирован с помощью ИИ последнего поколения.',
  newFeatureTryBtn: 'ПОЛУЧИТЬ ДОСТУП',

  newFeatureUpdateTitle: 'Обновление системы',
  newFeatureUpdateDesc: 'Мы внедрили продвинутый алгоритм анализа, который позволяет искать уязвимости ещё лучше. Используйте ИИ-ассистента для поиска векторов атаки.',

  // AI Assistant Improvements
  aiAssistantSlowResponse: 'Высокая нагрузка, хакер не успевает. Ответ может занять больше времени...',
  aiAssistantCharLimit: 'Слишком длинное сообщение. Максимум 5000 символов.',
  aiAssistantSendHint: 'Ctrl + Enter для отправки',
  aiAssistantPlaceholder: 'Опиши задачу или проблему...',
  aiAssistantDisclaimer: 'Хакер может ошибаться. Проверяй инфу.',
  aiAssistantInviteRcon: 'Нужна помощь с RCON?',
  aiAssistantInviteBots: 'Бот закончил работу. Какие-то проблемы?',
  aiAssistantInviteDdos: 'Атака остановлена. Хочешь обсудить защиту сервера?',
  aiAssistantInviteParser: 'Парсинг окончен. Хочешь найти уязвимости в этих серверах?',
  aiAssistantInviteData: 'Данные извлечены. Поищем точки входа?',
  aiAssistantInviteAccounts: 'Проверка аккаунтов завершена. Помочь с анализом?',

  // Minigames
  topPlayers: 'ТОП Игроков',
  score: 'Счет',
  rank: 'Место',
  player: 'Игрок',
  highScore: 'Рекорд',
  newRecord: 'Новый рекорд!',
  loadingLeaderboard: 'Загрузка лидеров...',
  failedToLoadLeaderboard: 'Не удалось загрузить ТОП',
};

export default ru;
